export default __webpack_public_path__ + "static/media/6.19247d59.svg";